import React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

import { checkValue } from 'src/components/common/helper';

export const getURLPath = (url, pathportion) => {
  let subPath = '';
  if (checkValue(url)) {
    const path = url.split('?')[0];
    if (checkValue(path)) {
      const tempPath = path.replace(/\/$/, '');
      if (pathportion === 'end') {
        subPath = tempPath.substring(tempPath.lastIndexOf('/') + 1);
      }
    }
  }
  return subPath;
};

export const getMenuItems = (data, isMobileMenu) => {
  const menuItemsArr = [];

  if (checkValue(data, true)) {
    const navItems = data;
    const currentPath = getURLPath(window.location.href, 'end');

    const menuItems = navItems.filter((menu) => {
      return menu.module === 'navigationItem' || menu.module === 'navigationItemReuse';
    });

    if (menuItems.length > 0) {
      menuItems?.forEach((mi, index) => {
        const { navigationItemText, navigationItemUrl, openUrlInNewTab } = mi;
        const openNewTab = checkValue(openUrlInNewTab) && openUrlInNewTab === 'True' ? true : false;
        if (checkValue(navigationItemText) && checkValue(navigationItemUrl)) {
          const menuPath = getURLPath(navigationItemUrl, 'end');
          const menuItemData = {
            attributes: { role: 'menuitem', tabindex: index },
            className: `partner-header-simple-menu-item ${menuPath === currentPath ? 'selected' : ''}`,
            href: navigationItemUrl,
            label: <span dangerouslySetInnerHTML={{ __html: navigationItemText }} />,
            typeAnchor: true,
            target: openNewTab ? '_blank' : '_self',
            ...(isMobileMenu
              ? {
                  icon: {
                    component: <UitkIcon name="navigate_next" className="sub-header-simple-menu-item-icon" />,
                  },
                }
              : {}),
          };
          menuItemsArr.push(menuItemData);
        }
      });
    }
  }

  return menuItemsArr;
};

export const useSimpleMenuDataHook = (storeData, propData) => {
  let subHeaderMenuText = checkValue(propData?.subHeaderMenuText)
    ? propData?.subHeaderMenuText
    : storeData?.subHeaderMenuText;

  return { subHeaderMenuText };
};
